import React from "react";
import Image from "next/legacy/image";

import {
  TanyaHowToContainer,
  TanyaHowToImageWrapper,
  TanyaHowToContentMobile,
  TanyaHowToTitle,
  TanyaHowToSubTitle,
  TanyaHowToPaginationContainer,
  TanyaHowToPaginationItem,
  TanyaHowToPaginationButton,
  TanyaHowToHeading,
  TanyaHowToDesc,
  TanyaHowToContent
} from "./tanya-how-to.styles";
import { tanyaHowToData } from "./tanya-how-to.data";
import { useTanyaHowTo } from "./use-tanya-how-to";

const TanyaHowTo: React.FC = () => {
  const { activeScreen, handleActiveScreen, checkIsActiveScreen } =
    useTanyaHowTo();
  return (
    <TanyaHowToContainer>
      <TanyaHowToTitle>Cara ngerjain soal di CoLearn</TanyaHowToTitle>
      <TanyaHowToSubTitle>
        Gimana sih cara cari video pembahasan soal pakai fitur Tanya?
      </TanyaHowToSubTitle>

      <TanyaHowToPaginationContainer>
        {Object.keys(tanyaHowToData).map((screen, idx) => (
          <TanyaHowToPaginationItem key={`tanya-howto-${idx}`}>
            <TanyaHowToPaginationButton
              active={checkIsActiveScreen(screen)}
              onClick={() => handleActiveScreen(screen)}
            >
              {screen}
            </TanyaHowToPaginationButton>
            <TanyaHowToContent>
              <TanyaHowToHeading>
                {tanyaHowToData[screen]["heading"]}
              </TanyaHowToHeading>
              <TanyaHowToDesc>{tanyaHowToData[screen].desc}</TanyaHowToDesc>
            </TanyaHowToContent>
          </TanyaHowToPaginationItem>
        ))}
      </TanyaHowToPaginationContainer>
      <TanyaHowToContentMobile>
        <TanyaHowToHeading>
          {tanyaHowToData[activeScreen]["heading"]}
        </TanyaHowToHeading>
        <TanyaHowToDesc>{tanyaHowToData[activeScreen].desc}</TanyaHowToDesc>
      </TanyaHowToContentMobile>
      <TanyaHowToImageWrapper>
        <Image
          src={tanyaHowToData[activeScreen].image}
          alt={tanyaHowToData[activeScreen].altText}
          layout="fill"
          object-fit="fill"
        />
      </TanyaHowToImageWrapper>
    </TanyaHowToContainer>
  );
};

export { TanyaHowTo };
